import { render, staticRenderFns } from "./cLandingQuickLinks.vue?vue&type=template&id=6a967fc8&scoped=true"
import script from "./cLandingQuickLinks.vue?vue&type=script&lang=js"
export * from "./cLandingQuickLinks.vue?vue&type=script&lang=js"
import style0 from "./cLandingQuickLinks.vue?vue&type=style&index=0&id=6a967fc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a967fc8",
  null
  
)

export default component.exports